var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrousers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.38c0 1.337.874 2.43 2 2.62V4h-2v.38zM6 1h17v2H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.482 4.315V4H8.519v.315c0 1.452-1.11 2.64-2.519 2.796V26h5.71l2.48-16.701a.316.316 0 01.309-.27c.15 0 .29.113.308.27L17.287 26h5.71L23 7.111c-1.41-.156-2.518-1.344-2.518-2.796z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4H6v3c1.126-.19 2-1.283 2-2.62V4z"
  }))));
}

export default SvgTrousers;